import BulkUploadDataRooms from './BulkUploadDataRooms.component';

export default BulkUploadDataRooms;
